import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  comment: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.text.tertiary,
    fontFamily: "poppins",
    gap: "5px",
  },
  commentHead: {
    display: "flex",
    fontFamily: "poppins",
    justifyContent: "space-between",
    alignItems: "center",
    marginRight: "13px",
  },
  time: {
    color: theme.palette.text.tertiary,
    fontFamily: "poppins",
    fontSize: "14px",
  },
  replyBox: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "5px 15px",
    gap: "15px",
  },
  submitCommentField: {
    width: "100%",
    height: "100%",
    padding: "4px 12px 12px 12px",
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    // display: "flex",
    alignItems: "center",
    overflowY: "hidden",
    marginLeft: "4px",
  },
  submitCommentFieldWithAttachment: {
    width: "100%",
    minheight: "60px",
    height: "100px",
    padding: "4px 12px 12px 12px",
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    // display: "flex",
    alignItems: "center",
    overflowY: "hidden",
    marginLeft: "4px",
  },
  replyCommentField: {
    width: "87%",
    height: "120px",
    padding: "4px 12px 12px 12px",
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    // display: "flex",
    alignItems: "center",
    overflowY: "hidden",
    marginLeft: "4px",
    marginTop: "-70px",
  },
  submitButton: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "10px",
    marginLeft: "8px",
    minWidth: "44px",
    height: "44px",
  },
  replyCard: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "5px 15px",
    gap: "15px",
    width: "99%",
    margin: "4px 0px 10px 4px",
    backgroundColor: theme.palette.primary.main,
  },
  flexCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  flexBetween: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  showMoreButton: {
    border: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: "25px",
    width: "150px",
    marginTop: "10px",
    padding: "8px 0px",
    color: theme.palette.secondary.main,
  },
  showHideButton: {
    color: theme.palette.secondary.main,
    paddingLeft: "0px !important",
    fontSize: "14px !important",
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px !important",
    },
  },
  colorText: {
    color: theme.palette.secondary.main,
  },
  annotationText: {
    cursor: "pointer",
    color: "#008cdb",
    marginRight: "8px",
  },
  image: {
    marginLeft: "40px",
    borderRadius: "10px",
    cursor: "pointer",
  },
  buttons: {
    display: "flex",
    gap: "10px",
    marginRight: "10px",
  },
  commonIconButton: {
    padding: "0",
    margin: "0",
    minWidth: "25px",
  },
  repliesHead: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  replyDescription: {
    margin: "8px 0px 4px 66px",
    paddingRight: "4px",
  },
  replyIcons: {
    display: "flex",
    gap: "10px",
    marginRight: "10px",
    justifyContent: "flex-end",
  },
  timeStampDiv: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    backgroundColor: theme.palette.primary.main,
    padding: "2px 4px",
    color: "#A8A8A8",
    borderRadius: "4px",
    marginBottom: "4px",
  },
  btn: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "10px",
    padding: "5px 10px",
  },
  noCommentContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "90%",
    position: "relative",
  },
  noCommentContainerText: {
    position: "absolute",
    color: theme.palette.primary.main,
    width: "320px",
    height: "110px",
    left: "40%",
    top: "30%",
  },
  selectedComment: {
    backgroundColor: theme.palette.secondary.light,
    marginTop: "8px",
  },
  notSelectedComment: {
    backgroundColor: theme.palette.primary.main,
    marginTop: "8px",
  },
  //
  formControl: {
    alignItems: "center",
    justifyContent: "center",
    width: "150px",
    height: "40px",
    background: theme.palette.secondary.light,
    borderRadius: "10px",
  },
  dropdownDiv: {
    display: "flex",
    alignItems: "center",
    width: "150px",
    justifyContent: "space-between",
  },
  selectText: {
    marginLeft: "10px",
    fontFamily: "Poppins",
    fontSize: "14px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  arrowIcon: {
    marginRight: "10px",
    height: "20px",
    color: "white",
  },
  formLabelText: {
    height: "0%",
    width: "100%",
    opacity: "0",
    background: theme.palette.secondary.light,
  },
  dropDown: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    border: `1px solid ${theme.palette.text.tertiary}`,
    overflowY: "auto",
    "& ul.MuiList-padding": {
      paddingTop: "0px",
      paddingBottom: "0px",
    },
    "& li.MuiListItem-gutters": {
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
  highlightedBtn: {
    color: "#F9F9F9",
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: "20px",
    padding: "6px 12px",
    fontSize: "14px !important",
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px !important",
    },
  },
  simpleBtn: {
    color: theme.palette.text.tertiary,
    border: `1px solid ${theme.palette.text.tertiary}`,
    borderRadius: "20px",
    padding: "6px 12px",
    fontSize: "14px !important",
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px !important",
    },
  },
  highlightedIcon: {
    color: theme.palette.secondary.main,
  },
  simpleIcon: {
    color: theme.palette.text.tertiary,
  },
  userName: {
    margin: "0px 8px",
    fontSize: "14px !important",
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px !important",
    },
  },
  commentText: {
    fontSize: "14px !important",
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px !important",
    },
  },
}));

export default useStyles;
